import { __awaiter } from "tslib";
import { getToken } from 'pathfinder/store/appState';
import { ActionType } from 'sdk/models/Action/types';
import fandomToWiki from './fandomToWiki';
function getCurrentFandomsIds() {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function* () {
        const userProfile = yield window.SilverSurferSDK.getUserProfile();
        const myFandoms = (_b = (_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.activeData) === null || _a === void 0 ? void 0 : _a.MYFANDOM) !== null && _b !== void 0 ? _b : [];
        let fandomIds = [];
        if (Array.isArray(myFandoms) && myFandoms.length === 1) {
            fandomIds = (_e = (_d = (_c = myFandoms[0]) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.fandomIds) !== null && _e !== void 0 ? _e : [];
        }
        return fandomIds;
    });
}
function findFandomIdFromWikiId(wikiId) {
    var _a;
    return (_a = fandomToWiki.find((fandom) => fandom.wiki === wikiId)) === null || _a === void 0 ? void 0 : _a.fandom;
}
export function hasCurrentWikiInMyFandoms() {
    return __awaiter(this, void 0, void 0, function* () {
        const { current } = window.SilverSurferSDK.getContext();
        const wikiId = current.productId;
        const fandomId = findFandomIdFromWikiId(wikiId);
        if (!fandomId) {
            return false;
        }
        const fandomIds = yield getCurrentFandomsIds();
        return fandomIds.includes(fandomId);
    });
}
export function getWikiVisitCount() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { current } = window.SilverSurferSDK.getContext();
        const wikiId = current.productId;
        const userProfile = yield window.SilverSurferSDK.getUserProfile();
        const visitedWikis = ((_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.visitedProducts) === null || _a === void 0 ? void 0 : _a.mw) || {};
        return visitedWikis[wikiId];
    });
}
export function getVisitsWithinTimeFrame(timeFrame) {
    const { current, pages } = window.SilverSurferSDK.getContext();
    const wikiId = current.productId;
    const currentTime = Date.now();
    return pages.filter((page) => page.product === 'mw' && page.productId === wikiId && currentTime - page.time < timeFrame).length;
}
export function saveToMyFandoms(wikiId) {
    return __awaiter(this, void 0, void 0, function* () {
        const fandomIds = yield getCurrentFandomsIds();
        const fandomId = findFandomIdFromWikiId(wikiId);
        if (fandomIds.find((element) => element == fandomId)) {
            return;
        }
        const newIds = [fandomId, ...fandomIds];
        yield window.SilverSurferSDK.addActiveDataAction(getToken(), 'SetMyFandoms', ActionType.MYFANDOM, {
            fandomIds: newIds,
        });
    });
}
